import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';
import { addDays } from 'date-fns';

export default Factory.extend({
  email: () => faker.internet.email(),
  name: () => faker.person.fullName(),
  phoneNumber: () => faker.phone.number(),
  doNotSync: false,
  deleted: false,
  ccEmployee: false,
  assistantIds: () => [],
  hideFromHostList: false,
  department: () => faker.commerce.department(),

  profilePictureUrl: null,

  withProfilePhoto: trait({
    profilePictureUrl: '/assets/images/high-five-v-01.png',
  }),

  withEmployeeLocation: trait({
    afterCreate(employee, server) {
      server.create('employee-location', {
        employee,
        requiredDocumentApprovalExpiresAt: addDays(new Date(), 7),
      });
    },
  }),

  withDeniedEmployeeLocation: trait({
    afterCreate(employee, server) {
      server.create('employee-location', {
        employee,
        hasRequiredDocumentApproval: false,
      });
    },
  }),
});
